import { array, number, ord, string } from 'fp-ts';
import { useState } from 'react';
import { pipe } from 'fp-ts/function';
import { Product } from '@mews-commander/data-access';
import { useLanguageCode } from '@mews-commander/core';

export interface IndexedProduct extends Product {
    index: number;
}

interface OrderableMaybeNamedItem {
    ordering: number;
    name?: string | null;
}

export const sortByOrdering = pipe(
    number.Ord,
    ord.contramap((p: OrderableMaybeNamedItem) => p.ordering)
);

export const sortByName = pipe(
    string.Ord,
    ord.contramap((p: OrderableMaybeNamedItem) => p.name || '')
);

export const useFilteredProducts = (
    products: Product[]
): {
    productsToDisplay: IndexedProduct[];
    onSearchChange: (searchQuery: string) => void;
} => {
    const languageCode = useLanguageCode();
    const [searchQuery, onSearchChange] = useState('');

    const regexp = new RegExp(searchQuery, 'i');

    const indexedProducts: IndexedProduct[] = products.map((p, index) => ({
        ...p,
        name: p.names[languageCode],
        index,
    }));

    const productsToDisplay = pipe(
        indexedProducts,
        array.filter((p) => Object.values(p.names).some((name) => regexp.test(name))),
        array.sortBy([sortByOrdering, sortByName])
    );

    return {
        productsToDisplay,
        onSearchChange,
    };
};
